/* eslint-disable
    func-names,
    max-len,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const { gql } = require('@apollo/client');
const env = require('bench-environment').default;

const UPDATE_CURRENT_UI = gql`
  mutation selfServeUiSwitch($clientId: ID!, $unifiedBanking: Boolean!) {
    selfServeUiSwitch(clientId: $clientId, unifiedBanking: $unifiedBanking)
  }
`;

const deps = ['Model', '_'];
const factory = function (Model, _) {
  let ClientSettings;
  return (ClientSettings = (function () {
    ClientSettings = class ClientSettings extends Model {
      static initClass() {
        this.prototype.$resource = 'clientsettings';
      }

      $featureEnabled(feature) {
        return this.features != null ? this.features[feature] : undefined;
      }
      $featureDisabled(feature) {
        return !(this.features != null ? this.features[feature] : undefined);
      }

      $switchToNewUi(clientId) {
        const variables = { clientId, unifiedBanking: true };
        return this.$graphqlClient
          .mutate({ mutation: UPDATE_CURRENT_UI, variables })
          .then(result => {
            if (result.data.selfServeUiSwitch)
              window.location.replace(`${env.location.cwa}/client/${clientId}/welcome`);
            else return result;
          });
      }
      $uiVersion() {
        if (this.features != null) return this.features.unifiedBanking ? 'New' : 'Old';
        return undefined;
      }
    };
    ClientSettings.initClass();
    return ClientSettings;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.clientsettings', moduleDeps)
  .factory('ClientSettings', factory);
